import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setToRetrieveCounter } from '../../../orderSlice';

export default function useSetRetrieveCounter(count) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setToRetrieveCounter(count));
  }, [dispatch, count]);
}
